import React, { useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
    InputAdornment,
    Typography,
    Card,
    CardContent,
    Container,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Banner from "../../assets/Gpouram2.jpg";

export default function ContactForm() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        subject: "",
        email: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", formData);
    };

    return (
        <>
            {/* Banner Section */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: { xs: "220px", sm: "320px", md: "420px" },
                    overflow: "hidden",
                    borderBottom: "4px solid #d97706",
                }}
            >
                <img
                    src={Banner}
                    alt="Temple Banner"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        display: "block",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background:
                            "linear-gradient(135deg, rgba(217,119,6,0.3), rgba(251,146,60,0.3))",
                    }}
                />
            </Box>

            {/* Contact Form Section */}


            {/* Map and Address Section Side by Side */}
            <Box
                sx={{
                    background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                    py: 8,
                }}
            >
                <Container maxWidth="xl">
                    <Typography
                        variant="h3"
                        sx={{
                            textAlign: "center",
                            fontWeight: 700,
                            mb: 2,
                            color: "#d97706",
                            textShadow: "2px 2px 4px rgba(217,119,6,0.1)",
                        }}
                    >
                        Find Us Here
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            textAlign: "center",
                            color: "#92400e",
                            mb: 6,
                            fontSize: "1.1rem",
                        }}
                    >
                        Visit us at our temple location
                    </Typography>

                    <Grid container spacing={2}>

                        <Grid size={{ xs: 12, md: 5 }}>
                            <Card
                                sx={{
                                    height: { xs: "auto", md: "100%" },
                                    borderRadius: 4,
                                    boxShadow: "0 10px 40px rgba(217,119,6,0.2)",
                                    background: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    transition: "transform 0.3s ease",
                                    "&:hover": {
                                        transform: "scale(1.02)",
                                    },
                                }}
                            >
                                <CardContent sx={{ p: 5 }}>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: 700,
                                            mb: 4,
                                            color: "white",
                                            textAlign: "center",
                                            textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                                        }}
                                    >
                                        Visit Our Temple
                                    </Typography>

                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                                        <Box sx={{ display: "flex", gap: 2 }}>
                                            <Box
                                                sx={{
                                                    backgroundColor: "rgba(255,255,255,0.25)",
                                                    borderRadius: "50%",
                                                    p: 1.5,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "fit-content",
                                                }}
                                            >
                                                <LocationOnIcon sx={{ color: "white", fontSize: 32 }} />
                                            </Box>
                                            <Box>
                                                <Typography
                                                    variant="h6"
                                                    sx={{ color: "white", fontWeight: 600, mb: 1 }}
                                                >
                                                    Address
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: "rgba(255,255,255,0.95)",
                                                        fontSize: "1.1rem",
                                                        lineHeight: 1.8,
                                                    }}
                                                >
                                                    ஸ்ரீமன் வைகுண்ட நாராயணசுவாமி திருக்கோவில்<br />
                                                    மதகநெல்லூர் என்ற மதகநேரி<br /> செம்பிகுளம் போஸ்ட்,  <br />
                                                    ஆவரைகுளம் (மற்றும்) வடக்கன் குளம் அருகில்

                                                    திருநெல்வேலி - 627116, தமிழ்நாடு
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: "flex", gap: 2 }}>
                                            <Box
                                                sx={{
                                                    backgroundColor: "rgba(255,255,255,0.25)",
                                                    borderRadius: "50%",
                                                    p: 1.5,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "fit-content",
                                                }}
                                            >
                                                <PhoneIcon sx={{ color: "white", fontSize: 32 }} />
                                            </Box>
                                            <Box>
                                                <Typography
                                                    variant="h6"
                                                    sx={{ color: "white", fontWeight: 600, mb: 1 }}
                                                >
                                                    Contact
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        color: "rgba(255,255,255,0.95)",
                                                        fontSize: "1.1rem",
                                                        lineHeight: 1.8,
                                                    }}
                                                >
                                                    +91 9487311113<br />
                                                    arumugham.l@gmail.com
                                                </Typography>
                                            </Box>
                                        </Box>


                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Box
                                sx={{
                                    height: { xs: 400, md: "100%" },
                                    minHeight: { md: 500 },
                                    borderRadius: 4,
                                    overflow: "hidden",
                                    boxShadow: "0 10px 40px rgba(217,119,6,0.2)",
                                    border: "3px solid #fed7aa",
                                }}
                            >
                                <iframe
                                    title="Google Map"
                                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3948.8301076748457!2d77.61068347500964!3d8.219834291812672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOMKwMTMnMTEuNCJOIDc3wrAzNic0Ny43IkU!5e0!3m2!1sen!2sin!4v1763189482135!5m2!1sen!2sin"
                                    width="100%"
                                    height="100%"
                                    style={{
                                        border: 0,
                                    }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>


        </>
    );
}

// Orange Theme TextField Style
const orangeTextFieldStyle = {
    "& .MuiOutlinedInput-root": {
        backgroundColor: "#fffbeb",
        "& fieldset": {
            borderColor: "#fed7aa",
        },
        "&:hover fieldset": {
            borderColor: "#fb923c",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#d97706",
            borderWidth: 2,
        },
    },
    "& .MuiInputBase-input::placeholder": {
        color: "#92400e",
        opacity: 0.7,
    },
    "& .MuiInputBase-input": {
        color: "#78350f",
    },
};